import { Redirect } from 'expo-router';
import Head from 'expo-router/head';

import { DEFAULT_LOCALE } from '@todo/core/i18n/locales';

// Un-prefixed root. In production public/_redirects answers "/" with a 301 to
// /en before this page is served; the <Redirect> and meta refresh cover any
// other host.
export default function RootIndex() {
  return (
    <>
      <Head>
        <meta httpEquiv="refresh" content={`0;url=/${DEFAULT_LOCALE}`} />
      </Head>
      <Redirect href={{ pathname: '/[lang]', params: { lang: DEFAULT_LOCALE } }} />
    </>
  );
}
